import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { G, Path, Circle, Defs, ClipPath, Rect } from 'react-native-svg'

interface GiveChipsSVGProps {
  bgFill?: string
  iconFill?: string
}

export const GiveChipsSVG = ({
  bgFill = Palette['Brand/Cream'],
  iconFill = Palette['Global/Black'],
  ...rest
}: React.ComponentProps<typeof Svg> & GiveChipsSVGProps) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...rest}>
    <G clipPath="url(#clip0_8654_33490)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0.0410741C12.6703 0.0138714 12.3368 0 12 0C11.6632 0 11.3297 0.0138712 11 0.0410735C8.4376 0.252467 6.10347 1.26894 4.25114 2.83696C3.74151 3.26837 3.26834 3.74154 2.83693 4.25118C1.26892 6.1035 0.252459 8.43763 0.0410714 11C0.0138705 11.3298 0 11.6633 0 12C0 12.3368 0.0138721 12.6703 0.0410761 13C0.256813 15.615 1.31099 17.9922 2.93416 19.8623C3.3718 20.3665 3.8508 20.8338 4.36589 21.259C6.19945 22.7725 8.49023 23.7519 11 23.9589C11.3297 23.9861 11.6632 24 12 24C12.2304 24 12.4593 23.9935 12.6866 23.9807C12.0127 23.3815 11.4407 22.6702 11 21.876V22.9552C8.76579 22.7538 6.72421 21.8844 5.07653 20.5483L7.21385 18.411C8.08897 19.0653 9.10254 19.5448 10.2027 19.7973C10.1221 19.4463 10.0646 19.0865 10.0319 18.7195C7.12404 17.8693 5 15.1827 5 12C5 8.13401 8.13401 5 12 5C15.1827 5 17.8693 7.12404 18.7195 10.0319C19.0865 10.0646 19.4463 10.1221 19.7973 10.2027C19.5447 9.1025 19.0653 8.0889 18.4109 7.21376L20.5482 5.07641C21.8844 6.72411 22.7538 8.76575 22.9552 11H21.8761C22.6702 11.4407 23.3816 12.0127 23.9807 12.6866C23.9935 12.4593 24 12.2304 24 12C24 11.6633 23.9861 11.3298 23.9589 11C23.7519 8.49018 22.7724 6.19935 21.2589 4.36576C20.8337 3.85068 20.3663 3.37169 19.8621 2.93405C17.9921 1.31094 15.6149 0.256801 13 0.0410741ZM4.96092 3.54675C6.62827 2.15682 8.71324 1.25091 11 1.04484V4.06189C9.53928 4.24404 8.20085 4.82 7.09432 5.68017L4.96092 3.54675ZM1.04484 11C1.2509 8.71327 2.1568 6.62832 3.54671 4.96097L5.68011 7.0944C4.81997 8.20092 4.24403 9.53933 4.06189 11H1.04484ZM3.6432 19.1532C2.19878 17.4673 1.25565 15.3393 1.04485 13H4.0619C4.25055 14.5128 4.86157 15.8944 5.77325 17.0231L3.6432 19.1532ZM13 1.04484C15.3392 1.25564 17.4672 2.19873 19.1531 3.6431L17.023 5.77318C15.8944 4.86154 14.5128 4.25053 13 4.06189V1.04484Z"
        fill={iconFill}
      />
      <G clipPath="url(#clip1_8654_33490)">
        <Circle cx={18} cy={18} r={6} fill={iconFill} />
        <Path
          d="M18.375 15.1716C18.375 14.9645 18.2071 14.7966 18 14.7966C17.7929 14.7966 17.625 14.9645 17.625 15.1716L17.625 17.625L15.1716 17.625C14.9645 17.625 14.7966 17.7929 14.7966 18C14.7966 18.2071 14.9645 18.375 15.1716 18.375L17.625 18.375L17.625 20.8284C17.625 21.0355 17.7929 21.2034 18 21.2034C18.2071 21.2034 18.375 21.0355 18.375 20.8284L18.375 18.375H20.8284C21.0355 18.375 21.2034 18.2071 21.2034 18C21.2034 17.7929 21.0355 17.625 20.8284 17.625H18.375L18.375 15.1716Z"
          fill={bgFill}
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_8654_33490">
        <Rect width={24} height={24} fill={bgFill} />
      </ClipPath>
      <ClipPath id="clip1_8654_33490">
        <Rect width={12} height={12} fill={bgFill} transform="translate(12 12)" />
      </ClipPath>
    </Defs>
  </Svg>
)
